import React from 'react'
import imgGirl from '../../../../assets/pictures/girlHome.png'
import imgMen from '../../../../assets/pictures/menHome.png'
import './styles.css'

const CardDestiny = () => {
    return (
        <div className='contain-card-destiny'>
            <section className='card-destiny-home'>
                <img src={imgGirl} alt="girl-camera" />
                <div className='content-info-card-destiny'>
                    <h3>Destinos Nacionales</h3>
                    <p>Viaja por Colombia con Wellezy
                        precios y descuentos increíbles</p>
                    <button>
                        Ver mas
                    </button>
                </div>
            </section>
            <section className='card-destiny-home'>
                <img src={imgMen} alt="girl-camera" />
                <div className='content-info-card-destiny'>
                    <h3>Destinos Internacionales</h3>
                    <p>Viaja por Colombia con Wellezy
                        precios y descuentos increíbles</p>
                    <button>
                        Ver mas
                    </button>
                </div>
            </section>
        </div>
    )
}

export default CardDestiny